import React, { useState } from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { GREEN_CLOSE_BTN } from "../../../../../assets";
import { Paperclip } from "lucide-react";

interface ReasonForRecallModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
}

export const ReasonForRecallModal: React.FC<ReasonForRecallModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
}) => {
  const [reason, setReason] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  );

  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[412px]"
      edges="rounded-2xl"
    >
      <div className="w-full px-6 py-8 flex flex-col gap-y-6 relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-[#98A2B3] hover:text-gray-600 transition-colors"
        >
          <img src={GREEN_CLOSE_BTN} alt="Close" className="w-5 h-5" />
        </button>
        <h2 className="text-xl font-bold text-[#101828] text-center">
          Reason for Recall
        </h2>
        <textarea
          rows={8}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border border-[#E5E7EB] rounded-lg p-4 text-sm text-[#101828] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074] resize-none"
        />
        <div className="w-full flex items-center gap-3 pt-2">
          <button
            type="button"
            onClick={onAccept}
            className="w-full bg-[#00B074] text-white rounded-lg py-3 text-sm font-medium hover:bg-[#009060] transition-colors"
          >
            Accept
          </button>
          <button
            type="button"
            onClick={onDecline}
            className="w-full bg-[#E5E5E5] text-[#111827] rounded-lg py-3 text-sm font-medium hover:bg-[#D4D4D4] transition-colors"
          >
            Decline
          </button>
        </div>
      </div>
    </ModalV2>
  );
};

export default ReasonForRecallModal;
